import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import keepPlayingWidgetDollarDeImage from '../../../../assets/cash-offer/keep_playing_widget_dollar_de.png';
import keepPlayingWidgetDollarEnImage from '../../../../assets/cash-offer/keep_playing_widget_dollar_en.png';
import keepPlayingWidgetEuroDeImage from '../../../../assets/cash-offer/keep_playing_widget_euro_de.png';
import keepPlayingWidgetEuroEnImage from '../../../../assets/cash-offer/keep_playing_widget_euro_en.png';
import { getUserLanguage } from '../../../../i18n/helpers';
import { useStores } from '../../../../stores/useStores';
import type { CashOfferWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import styles from './CashOfferWidget.module.scss';

interface CashOfferWidgetProps {
  sizeType: WidgetSizeType;
  data: CashOfferWidgetDataType;
}

function getWidgetImageUrl(currencyCode: string, language: string): string {
  const isGerman = getUserLanguage(language) === 'DE';
  if (currencyCode === 'EUR') {
    return isGerman ? keepPlayingWidgetEuroDeImage : keepPlayingWidgetEuroEnImage;
  }
  return isGerman ? keepPlayingWidgetDollarDeImage : keepPlayingWidgetDollarEnImage;
}

function CashOfferWidgetComponent({ data, sizeType }: CashOfferWidgetProps) {
  const { cashOfferStore, userStore } = useStores();
  const { i18n } = useTranslation();
  const { profile } = userStore;

  const onClick = () => {
    cashOfferStore.openDialog();
  };

  const widgetImageUrl = getWidgetImageUrl(profile?.currency.code ?? 'USD', i18n.language);

  return (
    <WidgetWrapper className={styles.widgetRoot} dataTestId={data.dataTestId} sizeType={sizeType} onClick={onClick}>
      {sizeType === 'small' ? (
        <GeneralSmallWidget widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const CashOfferWidget = observer(CashOfferWidgetComponent);
